import api from "api/axios";

export const fetchNotifications = () => api.get("/push-notifications");
export const fetchNotificationById = (id) => api.get(`/push-notifications/${id}`);
export const createNotification = (data) => api.post("/push-notifications", data);
export const updateNotification = (id, data) => api.put(`/push-notifications/${id}`, data);
export const deleteNotification = (id, data) => api.delete(`/push-notifications/${id}`, { data });